import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { target: String }

  connect() {
    // Only run once - check if already triggered
    if (this.element.dataset.triggered) return
    this.element.dataset.triggered = "true"

    // Small delay to ensure the page is fully loaded
    setTimeout(() => {
      const targetElement = document.querySelector(this.targetValue)
      if (targetElement) {
        targetElement.click()
      }
      // Remove the element to prevent any further triggers
      this.element.remove()
    }, 100)
  }
}
